module.exports = __webpack_public_path__ + "img/logo_howert.96b43f1c.png";